import { get } from '../utils/api'

export const fetchNoticeListData = async (limitCnt, searchType, searchVal, pageIdx) => {
  try {
    const response = await get('/notice/list', {
      limitCnt: limitCnt, 
      searchType: searchType,
      searchParam: searchVal,
      pageIdx: pageIdx
    });
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  };
};

export const fetchNoticeDetailData = async (ntIdx) => {
  try {
    const response = await get('/notice/detail', {
      ntIdx: ntIdx, 
    });
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  };
};

